import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'filter-toggle',
  templateUrl: './filter-toggle.component.html',
  styleUrls: ['./filter-toggle.component.scss'],
})
export class FilterToggleComponent implements OnInit {
  constructor() {}

  @Input() value :boolean | 0 | 1;
  @Input() label :string;
  @Output() changeToggle :EventEmitter<boolean | 0 | 1> = new EventEmitter<
    boolean | 0 | 1
  >();
  @Input() options :{ output :'boolean' | 'binary' } = { output: 'boolean' };

  ngOnInit() :void {}

  onChange() {
    let output;
    switch (this.options?.output) {
      case 'binary':
        output = this.value ? 1 : 0;
        break;
      case 'boolean':
      default:
        output = this.value;
    }
    this.changeToggle.emit(output);
  }
}
